module.exports = __webpack_public_path__ + "img/plus.4e5314cd.svg";